module.exports = __webpack_public_path__ + "img/kamalgeeti.2a4502ec.jpg";